var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMind(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 77,
    viewBox: "0 0 61.299 74.937",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.634 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.304 14.125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.216,52.829a1.247,1.247,0,0,1-.879-.383L34.864,38.972A10,10,0,1,1,49.013,24.823l.161.161.162-.161a10.068,10.068,0,0,1,7.085-2.879,10.287,10.287,0,0,1,7.143,2.875,10.018,10.018,0,0,1,0,14.153L50.094,52.445A1.244,1.244,0,0,1,49.216,52.829ZM41.98,24.343A7.6,7.6,0,0,0,36.621,37.3L49.174,49.935,61.811,37.3A7.579,7.579,0,1,0,51.093,26.58l-1,1a1.2,1.2,0,0,1-1.757,0l-1-1A7.54,7.54,0,0,0,41.98,24.343Z",
    transform: "translate(-31.938 -21.883)",
    fill: "#121e59",
    stroke: "#121e59",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.693,6.852c14.82,0,23.9,10.822,24.919,21,.861,8.587-1.357,13.429-3.312,17.7a24.425,24.425,0,0,0-2.456,7.268c-.549,4.568,1.166,10.593,2.7,14.843a.539.539,0,0,1-.028.443.551.551,0,0,1-.352.283L39.742,75.919a.379.379,0,0,1-.107.015.4.4,0,0,1-.382-.287L36.8,67.374a4.106,4.106,0,0,0-3.627-2.909l-6.245-.409a6.78,6.78,0,0,1-6.29-6.237l-.557-7.525A2.428,2.428,0,0,0,18.749,48.3L15.9,46.879a.818.818,0,0,1-.381-1.071l4.9-10.878a4.9,4.9,0,0,0,.466-2.074c.014-4.328,1.273-25.924,24.7-26h.1m0-2.427h-.11c-25.972.088-27.108,24.46-27.121,28.422a2.493,2.493,0,0,1-.244,1.066l-4.909,10.9a3.248,3.248,0,0,0,1.509,4.239l2.845,1.422L18.22,58a9.176,9.176,0,0,0,8.551,8.48l6.246.41a1.65,1.65,0,0,1,1.459,1.176l2.45,8.273a2.822,2.822,0,0,0,3.459,1.923l27.422-7.523a2.984,2.984,0,0,0,2.021-3.892c-1.281-3.549-3.082-9.494-2.574-13.73.77-6.413,7.185-11.406,5.774-25.5C71.851,15.867,61.39,4.425,45.693,4.425Z",
    transform: "translate(-13.022 -4.425)",
    fill: "#121e59",
    stroke: "#121e59",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.088,53.812",
    transform: "translate(-19.718 -13.855)",
    fill: "#121e59",
    stroke: "#121e59",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9,41.619",
    transform: "translate(-17.39 -11.527)",
    fill: "#121e59",
    stroke: "#121e59",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMind);
export default __webpack_public_path__ + "static/media/mind.f87008d1088116d01a81d0173cdaffba.svg";
export { ForwardRef as ReactComponent };